import React from 'react'
import rocket from './images/rocket.svg'

export const RocketHorizontalRule = () => {
    return (
        <div className="w-11/12 max-w-6xl mx-auto">
            <img src={rocket} className="max-w-full" alt="rocket as horizontal rule" />
        </div>
    )
}
